import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { TIME_UNTIL_MOVING_TO_NEXT_IN_SECONDS } from 'app-constants'
import { Body } from 'components/styled/typography'
import { Flex } from 'components/styled/containers/flex'
import { updateInterviewState } from 'interview/actions/sequenced-interview'
import styled from 'styled-components'
import { BlinkStyle } from '../../timer'
import { BodyStyle } from 'components/styled/typography/styles'

const propTypes = {
  i18n: PropTypes.shape({
    sequencedInterview: PropTypes.shape({
      questionAnswerView: PropTypes.shape({
        submitInfoForward: PropTypes.string,
        submitInfoForward2: PropTypes.string,
      }).isRequired,
    }),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
}

const StyledContainer = styled.div`
  position: absolute;
  padding: ${({ theme }) => theme.space.s24} ${({ theme }) => theme.space.s16};
  top: 50%;
  transform: translate(0, -50%);
  background-color: ${({ theme }) => theme.color.blackO50};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  width: 100%;
`

export const StyledTimerText = styled.span`
  ${BodyStyle};
  color: ${props =>
    props.$timeLeft <= 10 ? props.theme.color.error110 : props.color};
  ${props => props.$timeLeft <= 10 && BlinkStyle};
  margin-bottom: 0 !important;
  font-weight: 600;
  padding: 0 ${({ theme }) => theme.space.s8};
`
export const StyledTimerTextContainer = styled(Flex)`
  ${BodyStyle};
  font-weight: 600;
  margin-bottom: 0;
  flex-wrap: wrap;
  color: ${({ theme, color }) =>
    color ? theme.color[color] : theme.color.white};
`

export class SubmitTimer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      startTimeInMs: Date.now(),
      currentTimeInMs: Date.now(),
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const currentTimeInMs = Date.now()
      this.setState({ currentTimeInMs })
    }, 500)
  }

  componentDidUpdate() {
    const { onSubmit, dispatch } = this.props
    const { startTimeInMs, currentTimeInMs } = this.state
    const timePassedInSeconds = Math.round(
      (currentTimeInMs - startTimeInMs) / 1000
    )

    const timeLeft = TIME_UNTIL_MOVING_TO_NEXT_IN_SECONDS - timePassedInSeconds

    dispatch(updateInterviewState({ timeLeftTilNextQuestion: timeLeft }))
    // check time

    if (timePassedInSeconds === TIME_UNTIL_MOVING_TO_NEXT_IN_SECONDS) {
      clearInterval(this.interval)
      onSubmit()
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const { i18n } = this.props
    const { startTimeInMs, currentTimeInMs } = this.state
    const { questionAnswerView } = i18n.sequencedInterview
    const timePassedInSeconds = Math.round(
      (currentTimeInMs - startTimeInMs) / 1000
    )
    const timeLeft = TIME_UNTIL_MOVING_TO_NEXT_IN_SECONDS - timePassedInSeconds

    return (
      <StyledContainer>
        <StyledTimerTextContainer alignItems="center">
          {questionAnswerView.submitInfoForward}
          <StyledTimerText className="timer" color="white" $timeLeft={timeLeft}>
            {timeLeft}
          </StyledTimerText>
          {questionAnswerView.submitInfoForward2}
        </StyledTimerTextContainer>
      </StyledContainer>
    )
  }
}

SubmitTimer.propTypes = propTypes

export default connect(mapLanguageToComponentProps())(SubmitTimer)
